import { component } from 'picoapp'

class Scroll {

  constructor(node, ctx) {
    // bindings
    this.onResize = this.onResize.bind(this)
    this.onScroll = this.onScroll.bind(this)

    // selectors
    this._node = node
    this._wrapper = document.getElementById('wrapper')
    this._header = document.getElementById('header')

    // privates
    this._ctx = ctx;
    this._event_horizon = 0

    // event listeners
    window.addEventListener('resize', this.onResize)
    window.addEventListener('scroll', this.onScroll)
    window.dispatchEvent(new Event('resize'))

    // unmount
    return this.unmount.bind(this)
  }

  //
  // Resize.
  //
  onResize() {
    this.onScroll()
  }

  //
  // Scroll.
  //
  onScroll() {
    if (document.body.classList.contains('pjaxin')) {
      return false
    }

    this._event_horizon = window.pageYOffset

    if (this._event_horizon >= 24 && this._header.classList.contains('fill') === false) {
      this._header.classList.add('fill')
    } else if (this._event_horizon < 24 && this._header.classList.contains('fill') === true) {
      this._header.classList.remove('fill')
    }
  }

  //
  // Unmount.
  //
  unmount() {
    window.removeEventListener('resize', this.onResize)
    window.removeEventListener('scroll', this.onScroll)
  }
}

export default component((node, ctx) => new Scroll(node, ctx))
